export default function Step5() {
    return (
        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="path-1-inside-1_4031_17903" fill="white">
                <path d="M35 31.6271C39.0501 31.6271 42.3333 28.3439 42.3333 24.2938C42.3333 20.2437 39.0501 16.9604 35 16.9604" />
            </mask>
            <path
                d="M35 31.6271V32.6271C39.6024 32.6271 43.3333 28.8962 43.3333 24.2938H42.3333H41.3333C41.3333 27.7916 38.4978 30.6271 35 30.6271V31.6271ZM42.3333 24.2938H43.3333C43.3333 19.6914 39.6024 15.9604 35 15.9604V16.9604V17.9604C38.4978 17.9604 41.3333 20.796 41.3333 24.2938H42.3333Z"
                fill="black"
                mask="url(#path-1-inside-1_4031_17903)"
            />
            <path
                d="M35 31.6271C39.0501 31.6271 42.3333 28.3439 42.3333 24.2938C42.3333 20.2437 39.0501 16.9604 35 16.9604"
                stroke="black"
                strokeWidth="3"
                strokeLinejoin="round"
            />
            <mask id="path-4-inside-2_4031_17903" fill="white">
                <path d="M13.0013 16.9604C8.95121 16.9604 5.66797 20.2437 5.66797 24.2938C5.66797 28.3439 8.95121 31.6271 13.0013 31.6271" />
            </mask>
            <path
                d="M13.0013 16.9604V15.9604C8.39893 15.9604 4.66797 19.6914 4.66797 24.2938H5.66797H6.66797C6.66797 20.796 9.5035 17.9604 13.0013 17.9604V16.9604ZM5.66797 24.2938H4.66797C4.66797 28.8962 8.39893 32.6271 13.0013 32.6271V31.6271V30.6271C9.5035 30.6271 6.66797 27.7916 6.66797 24.2938H5.66797Z"
                fill="black"
                mask="url(#path-4-inside-2_4031_17903)"
            />
            <path
                d="M13.0013 16.9604C8.95121 16.9604 5.66797 20.2437 5.66797 24.2938C5.66797 28.3439 8.95121 31.6271 13.0013 31.6271"
                stroke="black"
                strokeWidth="3"
                strokeLinejoin="round"
            />
            <path
                d="M13 31.6271V31.1688V28.8771V24.2938V16.9604C13 10.8853 17.9249 5.96045 24 5.96045C30.0751 5.96045 35 10.8853 35 16.9604V31.6271C35 37.7022 30.0751 42.6271 24 42.6271"
                stroke="black"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
